const FLORA_INPUT_PLACEHOLDER = 'Ask Flora, @ for object mentions, / for commands';

/** Number of lines a sent user message shows before it collapses behind "Show more". */
const USER_MESSAGE_CLAMP_LINES = 8;

/**
 * Visual treatment of a status tag on a tool-call row or card.
 * - `Default`: the standard green status tag ("Writing…", "Drafted").
 * - `Subtle`: a muted tag for informational metadata ("Auto-approved").
 * - `Danger`: a red tag for a call that did not run ("Blocked by auto mode").
 */
enum ToolCallTagVariant {
  Default = 'default',
  Subtle = 'subtle',
  Danger = 'danger',
}

/**
 * Display data for the tag shown on a tool call auto mode decided on.
 */
interface AutoModeTag {
  /** Short visible label. */
  label: string;
  /** Hover tooltip explaining what auto mode did. */
  tooltip: string;
  variant: ToolCallTagVariant;
}

export { FLORA_INPUT_PLACEHOLDER, ToolCallTagVariant, USER_MESSAGE_CLAMP_LINES };
export type { AutoModeTag };
